
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/best-castle-stays-to-live-your-best-life",
      function () {
        return require("private-next-pages/blog/best-castle-stays-to-live-your-best-life.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/best-castle-stays-to-live-your-best-life"])
      });
    }
  